import http from '@/plugins/axios_plugin';

class ServiceEntregas {
    listar () {
        return http.get('/api/entregas/listar')
    }
    
    copiarPedido (pedido_id) {
        return http.get('/api/entregas/pedido/copiar/' + pedido_id)
    }
    
    salvar (post) {
        return http.post('/api/entregas/salvar', post)
    }

    cancelar (entrega) {
        return http.post('/api/entregas/cancelar', entrega)
    }
}

export default new ServiceEntregas();